import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isTechnicalDataShoppingCartEnabledSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('technicalDataShoppingCartButton'),
)

export default isTechnicalDataShoppingCartEnabledSelector
